import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=56ea88a9&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ea88a9"]])

export default __exports__